/**
 * The result objects a Tactic API error may carry, most specific first: a
 * `ResponseWithStatus` passed directly (`error.result`), an `ApiClientError`
 * (`error.response.result`), or the result object on its own.
 */
export function apiErrorBodies(error: unknown): Record<string, unknown>[] {
  if (!error || typeof error !== "object") {
    return [];
  }

  const err = error as Record<string, unknown>;
  const bodies: Record<string, unknown>[] = [];

  if ("ok" in err && err.result && typeof err.result === "object") {
    bodies.push(err.result as Record<string, unknown>);
  }

  if (err.response && typeof err.response === "object") {
    const response = err.response as Record<string, unknown>;
    if (response.result && typeof response.result === "object") {
      bodies.push(response.result as Record<string, unknown>);
    }
  }

  bodies.push(err);
  return bodies;
}
